var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.avatarClass,style:(_vm.avatarStyles)},[_c('LazyLoadingImage',{attrs:{"rounded":true,"source":_vm.photo.default,"sourceset":_vm.photo.retina}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }